import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_2 = { class: "text-center mb-10" }
const _hoisted_3 = { class: "text-dark mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: "media/svg/brand-logos/facebook-4.svg",
  class: "mb-1 me-3"
}, null, -1)
const _hoisted_6 = { class: "text-gray-400 fw-bold fs-4" }
const _hoisted_7 = { class: "fv-row mb-5" }
const _hoisted_8 = { class: "form-label fs-6 fw-bolder text-dark" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger fw-normal" }, "*", -1)
const _hoisted_10 = { class: "mx-2 text-gray-500 fw-normal" }
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "fv-row mb-5" }
const _hoisted_14 = { class: "d-flex flex-stack mb-2" }
const _hoisted_15 = { class: "form-label fw-bolder text-dark fs-6 mb-0" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger fw-normal" }, "*", -1)
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "fv-row mb-5" }
const _hoisted_20 = { class: "d-flex flex-stack mb-2" }
const _hoisted_21 = { class: "form-label fw-bolder text-dark fs-6 mb-0" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger fw-normal" }, "*", -1)
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "fv-row mb-5" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack mb-2" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 mb-0" }, [
    /*#__PURE__*/_createTextVNode("Email "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-danger fw-normal" }, "*")
  ])
], -1)
const _hoisted_27 = { class: "fv-plugins-message-container" }
const _hoisted_28 = { class: "fv-help-block" }
const _hoisted_29 = { class: "fv-row mb-10" }
const _hoisted_30 = { class: "d-flex flex-stack mb-2" }
const _hoisted_31 = { class: "form-label fw-bolder text-dark fs-6 mb-0" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger fw-normal" }, "*", -1)
const _hoisted_33 = { class: "mx-2 text-gray-500 fw-normal" }
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "text-center" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "indicator-label" }
const _hoisted_39 = { class: "text-center text-muted text-uppercase fw-bolder mb-5" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "media/svg/brand-logos/facebook-4.svg",
  class: "h-20px me-3"
}, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "media/svg/brand-logos/facebook-4.svg",
  class: "h-20px me-3"
}, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "media/svg/brand-logos/facebook-4.svg",
  class: "h-20px me-3"
}, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "media/svg/brand-logos/facebook-4.svg",
  class: "h-20px me-3"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        (this.$route.name === 'registerFB')
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _hoisted_5,
              _createTextVNode("Facebook")
            ]))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.$t("register")), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createTextVNode(_toDisplayString(_ctx.$t("alreadyRegister")) + " ", 1),
        _createVNode(_component_router_link, {
          to: {name: 'login'},
          class: "link-primary fw-bolder"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("loginHere")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", _hoisted_8, [
        _createTextVNode(_toDisplayString(_ctx.$t("username")) + " ", 1),
        _hoisted_9,
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("usernameNote")), 1)
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        name: "username",
        class: "form-control form-control-solid",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
        autocomplete: "off"
      }, null, 512), [
        [_vModelText, _ctx.username]
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.usernameError ? _ctx.$t(_ctx.usernameError) : ""), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("label", _hoisted_15, [
          _createTextVNode(_toDisplayString(_ctx.$t("password")) + " ", 1),
          _hoisted_16
        ])
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "password",
        name: "password",
        class: "form-control form-control-solid",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
        autocomplete: "off"
      }, null, 512), [
        [_vModelText, _ctx.password]
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.passwordError ? _ctx.$t(_ctx.passwordError) : ""), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("label", _hoisted_21, [
          _createTextVNode(_toDisplayString(_ctx.$t("confirmPassword")) + " ", 1),
          _hoisted_22
        ])
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "password",
        name: "confirmPassword",
        class: "form-control form-control-solid",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirmPassword) = $event)),
        autocomplete: "off"
      }, null, 512), [
        [_vModelText, _ctx.confirmPassword]
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.confirmPasswordError ? _ctx.$t(_ctx.confirmPasswordError) : ""), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _hoisted_26,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        name: "email",
        class: "form-control form-control-solid",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event)),
        autocomplete: "off"
      }, null, 512), [
        [_vModelText, _ctx.email]
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.emailError ? _ctx.$t(_ctx.emailError) : ""), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("label", _hoisted_31, [
          _createTextVNode(_toDisplayString(_ctx.$t("phoneLabel")) + " ", 1),
          _hoisted_32,
          _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("phoneNote")), 1)
        ])
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        name: "mobile",
        class: "form-control form-control-solid",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.mobile) = $event)),
        autocomplete: "off"
      }, null, 512), [
        [_vModelText, _ctx.mobile]
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.mobileError ? _ctx.$t(_ctx.mobileError) : ""), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      (this.$route.name === 'register')
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submitRegister())),
              class: "btn btn-lg btn-primary w-100 mb-5"
            }, [
              _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t("normalRegister")), 1)
            ]),
            _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t("OR")), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.fbRegister())),
        class: "btn btn-lg btn-secondary w-100 mb-5"
      }, [
        _hoisted_40,
        _createTextVNode(" Facebook " + _toDisplayString(_ctx.$t("register")), 1)
      ]),
      _createElementVNode("button", {
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.fblogout())),
        class: "d-none btn btn-lg btn-light w-100 mb-5"
      }, [
        _hoisted_41,
        _createTextVNode(" Facebook Log out ")
      ]),
      _createElementVNode("button", {
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.fbstatus())),
        class: "d-none btn btn-lg btn-light w-100 mb-5"
      }, [
        _hoisted_42,
        _createTextVNode(" Facebook Status ")
      ]),
      _createElementVNode("button", {
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.fbtest())),
        class: "d-none btn btn-lg btn-light w-100 mb-5"
      }, [
        _hoisted_43,
        _createTextVNode(" Facebook Test ")
      ])
    ])
  ]))
}